module.exports = __webpack_public_path__ + "static/media/pic8.cf1a0179.jpg";